import api from "../services/api";
import { IEventListItem, IEventDetail } from "../models/IEvent";
import { CreateEventDTO, EditEventDTO } from "../types/event";

// Admin endpoints (SuperadminPolicy)
export const getAdminEvents = (): Promise<{ data: IEventListItem[] }> =>
  api.get("Event/admin");

export const getAdminEventById = (id: string): Promise<{ data: IEventDetail }> =>
  api.get(`Event/admin/${id}`);

export const createEvent = (dto: CreateEventDTO): Promise<{ data: IEventDetail }> =>
  api.post("Event", dto);

export const updateEvent = (id: string, dto: EditEventDTO): Promise<{ data: IEventDetail }> =>
  api.put(`Event/${id}`, dto);

export const deleteEvent = (id: string): Promise<{ data: boolean }> =>
  api.delete(`Event/${id}`);

// Selection lists for the assignment section (reuse existing endpoints).
//
// Tournaments: the dashboard's real list endpoint is the PAGINATED
// `GET Tournament/all` which returns ServiceResponse<{ items, pagination }>.
// The axios interceptor in `services/api.ts` already unwraps the
// ServiceResponse envelope and returns `response.data`, so `api.get` resolves
// to `{ data: { items, pagination }, success, message, errors }`. We request a
// large page (the dashboard has well under 1000 tournaments) and flatten to a
// simple `{ id, name, type }[]` for the multi-select. NOTE: there is NO
// `Tournament/list` endpoint — do not invent one.
export const getAllTournamentsForSelect = async (): Promise<{ id: string; name: string; type: string }[]> => {
  const res = (await api.get("Tournament/all", {
    params: { pageNumber: 1, pageSize: 1000, sortBy: "name", sortOrder: "asc" },
  })) as unknown as { data: { items: { id: string; name: string; type: string }[] } };
  return (res.data?.items || []).map((t) => ({ id: t.id, name: t.name, type: t.type }));
};

// Seasons: `GET season` returns ServiceResponse<List<SeasonDTO>>; the
// interceptor unwraps it so `.data` is the flat `ISeason[]` (each has
// id/name/typeName/isActive). We return the flat array for the multi-select.
export const getAllSeasonsForSelect = async (): Promise<{ id: string; name: string; typeName: string }[]> => {
  const res = (await api.get("season")) as unknown as { data: { id: string; name: string; typeName: string }[] };
  return (res.data || []).map((s) => ({ id: s.id, name: s.name, typeName: s.typeName }));
};
